import { ThemeProvider } from '@capturi/ui-theme'
import { Global } from '@emotion/react'
import { ComponentProps, FC } from 'react'

import globalStyles from './globalStyles'

export const CapturiThemeProvider: FC<ComponentProps<typeof ThemeProvider>> = ({
  children,
  ...props
}) => {
  return (
    <ThemeProvider {...props}>
      <Global styles={globalStyles} />
      {children}
    </ThemeProvider>
  )
}
